import { DayCellContentArg } from "@fullcalendar/core"
import { CustomDayCellContentWrapper } from "./styles"
import { useMemo } from "react"
import { SlLock } from "react-icons/sl"
import dayjs from "dayjs"

interface IProps {
	info: DayCellContentArg
	disabledDates: string[]
}

export default function CustomDayCellContent({ info, disabledDates }: IProps) {
	// The calendar runs on timeZone="utc", so info.date is a UTC-midnight instant
	// standing for a plain calendar day. disabledDates is already keyed by that UTC
	// day; reading the rest of the cell locally shifted it to the previous day west
	// of UTC, so the printed number and the lock icon fell on different cells.
	const date = info.date.getUTCDate() // Get the day of the month (1-31)
	const today = new Date() // Get today's date
	const cellDate = dayjs(info.date.toISOString().split("T")[0]) // Cell's calendar day
	const startOftoday = dayjs().startOf("day")

	const isToday =
		date === today.getDate() &&
		info.date.getUTCMonth() === today.getMonth() &&
		info.date.getUTCFullYear() === today.getFullYear()

	const isPast = cellDate.isBefore(startOftoday) ? true : false
	/* ---------------------------------- Hooks --------------------------------- */
	const dataDisabel = useMemo(() => {
		if (disabledDates.length === 0 || disabledDates === undefined) return
		const dateStr = info.date.toISOString().split("T")[0]
		return disabledDates.includes(dateStr)
	}, [info, disabledDates])
	return (
		<CustomDayCellContentWrapper $isToday={isToday} $isPast={isPast}>
			<span className='days'>{date}</span>
			{dataDisabel && (
				<div className='dataDisabel'>
					<div>
						<SlLock />
					</div>
				</div>
			)}
		</CustomDayCellContentWrapper>
	)
}
